import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

const functions = getFunctions(app);

export const getUserRole = async (): Promise<string | null> => {
	try {
		const getClaims = httpsCallable(functions, "getUserClaims");
		const result: any = await getClaims();
		return result.data?.claims?.rol || null;
	} catch (error) {
		console.error("Error al obtener el rol del usuario:", error);
		return null;
	}
};
